import React, {useContext} from 'react';
import {Row} from '@yandex-data-ui/page-constructor';

import {NavigationItemExtended} from 'models/app';
import {getNavigationItemUrl} from 'units/navigation/utils';
import {List, NavigationSectionType, Location} from 'units/navigation/models';
import NavigationCategorizedItem from 'units/navigation/components/NavigationCategorizedItem/NavigationCategorizedItem';
import {NavigationItemBlockSize} from 'units/constructor-local/models';
import NavigationIcon from 'units/navigation/components/NavigationItems/NavigationIcon/NavigationIcon';
import Tag from 'units/navigation/components/NavigationItems/Tag/Tag';
import RouterContext from 'contexts/RouterContext';

export interface NavigationItemsListSOwnProps {
    size: NavigationItemBlockSize;
}

type NavigationItemsListSProps = NavigationItemsListSOwnProps & List & Location;

const ListS: React.FC<NavigationItemsListSProps> = ({navigationItems, location, type, size}) => {
    const router = useContext(RouterContext);

    return (
        <Row>
            {navigationItems.map((item: NavigationItemExtended) => {
                const url = getNavigationItemUrl(item, type, router.pathname, location === 'popup');
                const tag = <Tag item={item} type={type} tagProps={{size: 's'}} />;
                const icon =
                    type === NavigationSectionType.Services ? (
                        <NavigationIcon type={type} iconProps={{name: item.slug}} />
                    ) : null;

                return (
                    <NavigationCategorizedItem
                        key={item.id}
                        id={item.slug}
                        url={url}
                        description={item.description}
                        title={item?.name || ''}
                        size={size}
                        tag={tag}
                        icon={icon}
                        type={type}
                    />
                );
            })}
        </Row>
    );
};

export default ListS;
